export interface CheckoutAddress {
  addressCategoryCode: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressOverride: boolean;
  countryCode: string;
  postalCode: string;
  region: string;
}
